<template>
  <div v-bind="$attrs">
    <transition name="fade">
      <div v-if="state.dirty || state.errors.length">
        <ul
          v-if="state.errors.length && messages"
          :class="$style.messages"
        >
          <li
            v-for="(error, index) in state.errors"
            :key="index"
          >
            {{ error }}
          </li>
        </ul>
        <template
          v-else-if="!messages"
        >
          <span
            v-if="state.invalid"
            :class="[$style.indicator, $style.indicator__ERROR]"
          >

            <UiIcon
              name="warning"
              height="18"
            />
          </span>
          <span
            v-else-if="value === undefined || value.length"
            :class="$style.indicator"
          >
            <UiIcon
              name="tick"
              height="13"
            />
          </span>
        </template>
      </div>
    </transition>
  </div>
</template>
<script>
import UiIcon from '../../UiIcon'
export default {
  components: {
    UiIcon
  },
  props: {
    value: {
      type: [String, Number, Boolean, undefined],
      default: undefined
    },
    messages: {
      type: Boolean,
      default: false
    },
    state: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" module>
@import "../../../styles/shared";

.messages {
  margin: 0;
  padding: 0;
  list-style: none;
  color: $color-ui-error;
  font-size: 1.4rem;
  line-height: 2rem;
}

.indicator {
  display: inline-flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  background: $color-ui-success;
  color: #fff;
  transition: background $transition-duration $transition-function;

  &__ERROR {
    background: $color-ui-error;
  }
}

</style>
